/**
 * SELECT Options 对应的 item 的字段
 * @type {{CODE: 'value值', LABEL: '显示名称'}}
 */
export const SELECT_OPTION_CONFIG = {
  LABEL: "label",
  CODE: "code",
  CHILDREN: "children",
  VISIBLE: "visible"
};
// 广告位 对应的 code
export const AD_CODE = {
  // banner 图
  AD_HT_BANNER: "ad_ht_banner",
  // banner 图
  BANNER: "banner",
  // 首页 一号广告位
  AD_A: "ad_a",
  // 首页 二号广告位
  AD_B: "ad_b",
  AD_C: "ad_c",
  AD_D: "ad_d",
  // 项目聚焦
  AD_IMPORTANT: "ad_zdtj",
  // 公告展示
  AD_NOTICE: "ad_ggzs"
}
// 顶层导航栏 对应的code  方便向下查找
export const TOP_NAV_MENU_CODE = {
  // 场所服务
  SITE_SERVICE: "csfw",
  // 平台管理
  PLATFORM_MANAGE: "ptgl",
  // 监督管理
  SUPERVISION: "jdgl",
  // 服务指南
  SERVICE_GUIDE: "fwzn",
  // 信息发布
  NEWS_INFO: "news",
  // 政策法规
  POLICY_REGULATION: "zcfg",
  // 关于我们
  ABOUT_US: "gywm",
  // 近期开标
  RECENT_OPEN_BIDDING: "jqkb",
  // 交易指南
  JYZN: "jyzn"

}

// 头部导航的所有code 配置时 记得添加
export const NAV_MENU_CODE = {
  ...TOP_NAV_MENU_CODE,
  // 首页
  HOME: "home",
  // 阳光招标采购
  PURCHASE: "xmxx",
  // 产权
  GYZCJY: "xmgg_gyzcjy",
  ZRZCJY: "xmgg_zrzyjy",
  // 信息发布
  NEWS_INFO: "news",
  // 政策法规
  POLICY_REGULATION: "zcfg",
  // 政策规则
  POLICY_RULES: "zcgz",
  // 服务指南
  SERVICE_GUIDE: "ywzn",
  // 平台动态
  PLATFORM_UPDATES: "ptdt",
  // 通知公告
  NOTICES: "tzgg",
  // 新闻动态
  XTDT: "xtdt",
  // 招商公告
  ZSGG: "zsgg",
  // 新闻轮播
  XWLB: "xwlb",
  // 常见问题
  FAQ: "cjwt",
  // 关于我们
  ABOUT_US: "gywm",
  // 近期开标
  RECENT_OPEN_BIDDING: "jqkb",
  // 结果公告产权交易
  CJGGCQJY: "cjgg_cqjy",
  // 结果公告招标采购
  CJGGZBCG: "cjgg_zbcg",
  // 变更公告产权交易
  BGGGCQJY: "bggg_cqjy",
  // 变更公告招标采购
  BGGGZBCG: "bggg_zbcg",
  // 操作指南
  CZZN: "czzn",
  KJCGZH: "kjcgzh",
  NCCQJY: "nccqjy"
}

// 公告类型 枚举值
export const NOTICE_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: ""
  },
  GKZB: {
    [SELECT_OPTION_CONFIG.LABEL]: "采购公告",
    [SELECT_OPTION_CONFIG.CODE]: "gkzb"
  },
  JZXTP: {
    [SELECT_OPTION_CONFIG.LABEL]: "竞争性谈判",
    [SELECT_OPTION_CONFIG.CODE]: "jzxtp"
  },
  JZXCS: {
    [SELECT_OPTION_CONFIG.LABEL]: "竞争性磋商",
    [SELECT_OPTION_CONFIG.CODE]: "jzxcs"
  },
  XJCG: {
    [SELECT_OPTION_CONFIG.LABEL]: "询价采购",
    [SELECT_OPTION_CONFIG.CODE]: "xjcg"
  },
  DYLY: {
    [SELECT_OPTION_CONFIG.LABEL]: "单一来源采购",
    [SELECT_OPTION_CONFIG.CODE]: "dyly"
  }
};

// 项目类型枚举值
export const PROJECT_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: "",
    EN: "ALL"
  },
  GC: {
    [SELECT_OPTION_CONFIG.LABEL]: "工程类",
    [SELECT_OPTION_CONFIG.CODE]: "GC",
    EN: "ENGINEERING"
  },
  HW: {
    [SELECT_OPTION_CONFIG.LABEL]: "货物类",
    [SELECT_OPTION_CONFIG.CODE]: "HW",
    EN: "GOODS"
  },
  FW: {
    [SELECT_OPTION_CONFIG.LABEL]: "服务类",
    [SELECT_OPTION_CONFIG.CODE]: "FW",
    EN: "SERVICE"
  },
  QT: {
    [SELECT_OPTION_CONFIG.LABEL]: "其他",
    [SELECT_OPTION_CONFIG.CODE]: "QT",
    EN: "OTHER"
  }
  // JCCG: {
  //   [SELECT_OPTION_CONFIG.LABEL]: "建材采购",
  //   [SELECT_OPTION_CONFIG.CODE]: "JCCG",
  //   EN: "BUILDING_MATERIALS"
  // }
};
// 企业类型(省属企业：1 地市企业：2 其他企业：3)
export const UNIT_TYPE = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: "",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  PROVINCE: {
    [SELECT_OPTION_CONFIG.LABEL]: "省属企业",
    [SELECT_OPTION_CONFIG.CODE]: "1",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  CITY: {
    [SELECT_OPTION_CONFIG.LABEL]: "地市企业",
    [SELECT_OPTION_CONFIG.CODE]: "2",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  OTHER: {
    [SELECT_OPTION_CONFIG.LABEL]: "其他企业",
    [SELECT_OPTION_CONFIG.CODE]: "3",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  }
}
export const PROJECT_STATUS_OPTIONS2 = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: "",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  WKS: {
    [SELECT_OPTION_CONFIG.LABEL]: "未开始",
    [SELECT_OPTION_CONFIG.CODE]: "NOT_START",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  BMZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "正在报名",
    [SELECT_OPTION_CONFIG.CODE]: "START_BM",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  BMJZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "报名已截止",
    [SELECT_OPTION_CONFIG.CODE]: "END_BM",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  GSZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "竞价中",
    [SELECT_OPTION_CONFIG.CODE]: "START_BID",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  GSJS: {
    [SELECT_OPTION_CONFIG.LABEL]: "竞价截止",
    [SELECT_OPTION_CONFIG.CODE]: "END_BID",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  YZB: {
    [SELECT_OPTION_CONFIG.LABEL]: "已成交",
    [SELECT_OPTION_CONFIG.CODE]: "YES_CJ",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  }
};
// 项目状态枚举值
export const PROJECT_STATUS_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: "",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  WKS: {
    [SELECT_OPTION_CONFIG.LABEL]: "未开始",
    [SELECT_OPTION_CONFIG.CODE]: "0",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  BMZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "报名中",
    [SELECT_OPTION_CONFIG.CODE]: "1",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  BMJZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "报名截止",
    [SELECT_OPTION_CONFIG.CODE]: "2",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  GSZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "公示中",
    [SELECT_OPTION_CONFIG.CODE]: "3",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  GSJS: {
    [SELECT_OPTION_CONFIG.LABEL]: "公示结束",
    [SELECT_OPTION_CONFIG.CODE]: "4",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  YZB: {
    [SELECT_OPTION_CONFIG.LABEL]: "已中标",
    [SELECT_OPTION_CONFIG.CODE]: "5",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  YFB: {
    [SELECT_OPTION_CONFIG.LABEL]: "已废标",
    [SELECT_OPTION_CONFIG.CODE]: "6",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  YCXZB: {
    [SELECT_OPTION_CONFIG.LABEL]: "已重新招标",
    [SELECT_OPTION_CONFIG.CODE]: "7",
    [SELECT_OPTION_CONFIG.VISIBLE]: false
  },
  ZBGS: {
    [SELECT_OPTION_CONFIG.LABEL]: "中标公示",
    [SELECT_OPTION_CONFIG.CODE]: "8",
    [SELECT_OPTION_CONFIG.VISIBLE]: false
  },
  XJGG: {
    [SELECT_OPTION_CONFIG.LABEL]: "详见公告",
    [SELECT_OPTION_CONFIG.CODE]: "9",
    [SELECT_OPTION_CONFIG.VISIBLE]: false
  },
  XJGS: {
    [SELECT_OPTION_CONFIG.LABEL]: "详见公示",
    [SELECT_OPTION_CONFIG.CODE]: "10",
    [SELECT_OPTION_CONFIG.VISIBLE]: false
  }
};

// 状态对应按钮文字
export const PROJECT_STATUS_BUTTON_TEXT = {
  "0": "未开始",
  "1": "报名",
  "2": "报名截止",
  "3": "我要参加",
  "4": "详见公告",
  "5": "已中标",
  "6": "已废标",
  "7": "重新招标",
  "8": "已中标",
  "9": "详见公告",
  "10": "详见公示",
  "default": "详见公告"
};

// 信息类型
export const INFO_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: ""
  },
  ZBGG: {
    [SELECT_OPTION_CONFIG.LABEL]: "采购公告",
    [SELECT_OPTION_CONFIG.CODE]: "1"
  },
  BGGG: {
    [SELECT_OPTION_CONFIG.LABEL]: "澄清/变更公告",
    [SELECT_OPTION_CONFIG.CODE]: "2"
  },
  ZBHXRGS: {
    [SELECT_OPTION_CONFIG.LABEL]: "中标候选人公示",
    [SELECT_OPTION_CONFIG.CODE]: "3"
  },
  ZBJG: {
    [SELECT_OPTION_CONFIG.LABEL]: "结果公告",
    [SELECT_OPTION_CONFIG.CODE]: "4"
  }
};

export const INFO_TYPE_OPTIONS2 = {
  CQJY: {
    [SELECT_OPTION_CONFIG.LABEL]: "产权交易",
    [SELECT_OPTION_CONFIG.CODE]: "CQJY"
  },
  ZBCG: {
    [SELECT_OPTION_CONFIG.LABEL]: "招标采购",
    [SELECT_OPTION_CONFIG.CODE]: "ZBCG"
  }
};

export const INFO_TYPE_OPTIONS3 = {
  BGGG: {
    [SELECT_OPTION_CONFIG.LABEL]: "变更公告",
    [SELECT_OPTION_CONFIG.CODE]: "BGGG"
  },
  JGGG: {
    [SELECT_OPTION_CONFIG.LABEL]: "结果公告",
    [SELECT_OPTION_CONFIG.CODE]: "JGGG"
  }
};
// 组织形式
export const ORGANIZATION_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.CODE]: "",
    [SELECT_OPTION_CONFIG.LABEL]: "全部"
  },
  WTCG: {
    [SELECT_OPTION_CONFIG.CODE]: "1",
    [SELECT_OPTION_CONFIG.LABEL]: "机构"
  },
  QYZZ: {
    [SELECT_OPTION_CONFIG.CODE]: "2",
    [SELECT_OPTION_CONFIG.LABEL]: "自主"
  }
};

export const MAP_ACTION = {
  SET: "set",
  DEL: "delete",
  HAS: "has",
  CLEAR: "clear"
};

export const PERMISSION_ROLE = {
  MENU: "MENU",
  SITE: "SITE"
};

// 友情链接 的枚举值
export const LINK_TYPE = {
  LINK_ZFBM: {
    [SELECT_OPTION_CONFIG.LABEL]: "政府部门",
    [SELECT_OPTION_CONFIG.CODE]: "link_zfbm"
  },
  LINK_JTBK: {
    [SELECT_OPTION_CONFIG.LABEL]: "集团板块",
    [SELECT_OPTION_CONFIG.CODE]: "link_jtbk"
  },
  LINK_HZJG: {
    [SELECT_OPTION_CONFIG.LABEL]: "合作机构",
    [SELECT_OPTION_CONFIG.CODE]: "link_hzjg"
  }
}
export const LINK_TYPE2 = {
  LINK_QSQY: {
    [SELECT_OPTION_CONFIG.LABEL]: "权属企业",
    [SELECT_OPTION_CONFIG.CODE]: "link_qsqy"
  }
}
/* export const LINK_TYPE = {
  // 发布媒体
  FBMT: "fbmt",
  // 采购代理机构
  CGDLJG: "cgdljg",
  // 区直国企
  QZGQ: "qzgq",
  // 国资监管
  GZJG: "gzjg",
  // 合作机构
  HZJG: "hzjg",
  // 合作机构
  FRIENDLY_LINK: "link"
};*/

/**
 * 注册页面使用的常量
 * @type {{REGISTER_TYPE_CGR: string, SYSTEM_XXFB: string, SYSTEM_QYZC: string, REGISTER_TYPE_GYS: string, SSJT_OTHER_CODE: number}}
 */
export const REGISTER_PAGE_CONSTANT = {
  // 所属集团 选择 其他 对应的 code
  SSJT_OTHER_CODE: -1,
  // 注册身份: 供应商
  REGISTER_TYPE_GYS: "17",
  // 注册身份: 采购人
  REGISTER_TYPE_CGR: "12",
  // 系统服务: 信息发布
  SYSTEM_XXFB: "1",
  // 系统服务: 企业自采
  SYSTEM_QYZC: "2"
};
/**
 * 获取 会员协议 对应的 页面类型
 * @type {{MEMBER_REGISTER: string, ENTERPRISE_ENTER: string}}
 */
export const PROTOCOL_PAGE_TYPE = {
  // 会员注册
  MEMBER_REGISTER: "1",
  // 入驻申请
  ENTERPRISE_ENTER: "2"
};

/**
 * 注册页面, 获取用户协议是, 对应的用户身份
 * @type {{GYS: string, CGR: string}}
 */
export const PROTOCOL_TYPE = {
  // 采购人
  [REGISTER_PAGE_CONSTANT.REGISTER_TYPE_CGR]: "cgr",
  // 供应商
  [REGISTER_PAGE_CONSTANT.REGISTER_TYPE_GYS]: "gys"
};

/**
 * 文件上传通用 url
 * @type {string}
 */
export const UPLOAD_FILE_URI =
  process.env.VUE_APP_BASE_API +
  process.env.VUE_APP_APP_API +
  "/infra/file/upload";

/**
 * 模版文件 code
 * @type {{SQS_FGS: string, SQS: string, SFZ: string}}
 * @desc {{SQS_FGS: 授权书模板(分公司注册版本), SQS: 授权书模板, SFZ: 身份证明}}
 */
export const TEMPLATE_CODE = {
  // 身份证明
  SFZ: "sfz",
  // 授权书模板
  SQS: "sqs",
  // 授权书模板(分公司注册版本)
  SQS_FGS: "sqs_fgs"
};
/**
 * 模版文件 pageType
 * @type {{ORG: string, MEMBER: string}}
 * @desc {{ORG: 入驻申请, MEMBER: 会员注册 }}
 */
export const TEMPLATE_PAGE_TYPE = {
  MEMBER: "member",
  ORG: "org"
};

// 头部搜索的  code
export const HEAD_SEARCH_CODE = {
  GYZCJY: NAV_MENU_CODE.GYZCJY,
  ZRZCJY: NAV_MENU_CODE.ZRZCJY,
  PURCHASE: NAV_MENU_CODE.PURCHASE,
  NOTICES: NAV_MENU_CODE.NOTICES,
  RESULT_NOTICE: INFO_TYPE_OPTIONS.ZBJG[SELECT_OPTION_CONFIG.CODE],
  SEARCH: "SEARCH"
}

/**
 * 适用于头部搜索框内,切换查询条件的下拉框
 * 下拉搜索范围为：阳光招标采购、通知公告、结果公示、综合搜索
 * @type {{PROJECT_CODE: {CODE: string, LABEL: string}, PROJECT_NAME: {CODE: string, LABEL: string}}}
 */
export const SEARCH_INPUT_OPTIONS_TYPES = {
  GYZCJY: {
    [SELECT_OPTION_CONFIG.LABEL]: "国有资产交易",
    [SELECT_OPTION_CONFIG.CODE]: HEAD_SEARCH_CODE.GYZCJY
  },
  ZRZCJY: {
    [SELECT_OPTION_CONFIG.LABEL]: "自然资产交易",
    [SELECT_OPTION_CONFIG.CODE]: HEAD_SEARCH_CODE.ZRZCJY
  },
  BIDDING_NOTICE: {
    [SELECT_OPTION_CONFIG.LABEL]: "阳光招标采购",
    [SELECT_OPTION_CONFIG.CODE]: HEAD_SEARCH_CODE.PURCHASE
  },
  // NOTICES: {
  //   [SELECT_OPTION_CONFIG.LABEL]: "通知公告",
  //   [SELECT_OPTION_CONFIG.CODE]: HEAD_SEARCH_CODE.NOTICES
  // },
  // RESULT_NOTICE: {
  //   [SELECT_OPTION_CONFIG.LABEL]: "结果公示",
  //   [SELECT_OPTION_CONFIG.CODE]: HEAD_SEARCH_CODE.RESULT_NOTICE
  // },
  BUSINESS_GUIDE: {
    [SELECT_OPTION_CONFIG.LABEL]: "资讯搜索",
    [SELECT_OPTION_CONFIG.CODE]: HEAD_SEARCH_CODE.SEARCH
  }
};

// 招商引资
export const ZSYZ_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: "",
    color: ""
  },
  PREPARE: {
    [SELECT_OPTION_CONFIG.LABEL]: "筹备中",
    [SELECT_OPTION_CONFIG.CODE]: "prepare",
    color: "#2ba4ec"
  },
  PROGRESS: {
    [SELECT_OPTION_CONFIG.LABEL]: "招商中",
    [SELECT_OPTION_CONFIG.CODE]: "progress",
    color: "#6db62e"
  },
  ENDED: {
    [SELECT_OPTION_CONFIG.LABEL]: "已结束",
    [SELECT_OPTION_CONFIG.CODE]: "ended",
    color: "#aaaaaa"
  }
}

export function getConstantDic(dicObj) {
  // eslint-disable-next-line no-prototype-builtins
  const isVisible = (item) => !item.hasOwnProperty(SELECT_OPTION_CONFIG.VISIBLE) || item[SELECT_OPTION_CONFIG.VISIBLE]
  return Object.values(dicObj).filter(item => isVisible(item))
}
